import React from 'react';
import { businessData } from '../data/mock';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__main">
          <div className="footer__brand">
            <img 
              src={businessData.logo} 
              alt={`${businessData.name} Logo`}
              className="footer__logo"
            />
            <p className="footer__tagline">
              Bar de cerveza artesanal en Rosario.
            </p>
          </div>
          
          <div className="footer__contact">
            <h4 className="footer__contact-title">Contacto</h4>
            <p>{businessData.address.full}</p>
            <p>WhatsApp: {businessData.contact.whatsappDisplay}</p>
            <p>{businessData.schedule.description}</p>
          </div>
        </div>
        
        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} Boulevard Cervecitas · Desarrollado por{' '}
            <a 
              href="https://www.somosappolo.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer__credit-link"
            >
              Appolo
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
